<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">智能体配置</span></div>
		<div class="h-panel-body">
			<Row type="flex" :space="30">
				<Cell :width="14">
					<Form :labelWidth="130">
						<FormItem label="启用智能体:">
							<HSwitch v-model="form.enabled"></HSwitch>
							<span class="ai-tip">开启后用户可在"财税智能体"中使用对话式记账与查询</span>
						</FormItem>
						<FormItem label="服务商快捷配置:">
							<Button v-for="p in providers" :key="p.key" size="s" style="margin-right: 8px;" @click="applyProvider(p)">{{ p.name }}</Button>
						</FormItem>
						<FormItem label="API 地址:">
							<input type="text" v-model="form.baseUrl" placeholder="https://api.deepseek.com/v1" style="width: 360px;"/>
							<div class="ai-tip">OpenAI 兼容接口基础地址</div>
						</FormItem>
						<FormItem label="API Key:">
							<input type="password" v-model="form.apiKey" placeholder="sk-..." style="width: 360px;"/>
						</FormItem>
						<FormItem label="模型名称:">
							<input type="text" v-model="form.model" placeholder="deepseek-chat" style="width: 360px;"/>
						</FormItem>
						<FormItem label="最大工具轮次:">
							<input type="number" v-model.number="form.maxRounds" min="1" max="50" style="width: 120px;"/>
							<div class="ai-tip">单次对话最多执行多少轮工具调用</div>
						</FormItem>
						<FormItem label="采样温度:">
							<input type="number" v-model.number="form.temperature" min="0" max="2" step="0.1" style="width: 120px;"/>
							<div class="ai-tip">0~2，数值越小回答越稳定</div>
						</FormItem>
						<FormItem label="最大 Token 数:">
							<input type="number" v-model.number="form.maxTokens" min="1" style="width: 120px;"/>
							<div class="ai-tip">单次回复生成的最大 Token 数</div>
						</FormItem>
						<FormItem>
							<Button color="primary" :loading="saving" @click="save">保存配置</Button>
							<Button :loading="testing" style="margin-left: 10px;" @click="test">测试连接</Button>
						</FormItem>
					</Form>
				</Cell>
				<Cell :width="8">
					<div class="ai-status">
						<div class="ai-status-title">当前状态</div>
						<div class="ai-status-row">状态：
							<span :class="form.enabled ? 'green-color' : 'red-color'">
								<b>{{ form.enabled ? '已启用' : '未启用' }}</b>
							</span>
						</div>
						<div class="ai-status-row">模型：{{ form.model || '-' }}</div>
						<div class="ai-status-tip">配置保存后即时生效，无需重启服务。</div>
						<div class="ai-status-tip">支持任意 OpenAI 兼容接口：DeepSeek、Kimi、通义千问、智谱 GLM 等。</div>
					</div>
				</Cell>
			</Row>
		</div>
	</app-content>
</template>

<script>
	export default {
		name: "AdminAiConfig",
		data() {
			return {
				saving: false,
				testing: false,
				form: {
					enabled: false,
					baseUrl: 'https://api.deepseek.com/v1',
					apiKey: '',
					model: 'deepseek-chat',
					maxRounds: 10,
					temperature: 0.3,
					maxTokens: 4096
				},
				providers: [
					{key: 'deepseek', name: 'DeepSeek', baseUrl: 'https://api.deepseek.com/v1', model: 'deepseek-chat'},
					{key: 'kimi', name: 'Kimi', baseUrl: 'https://api.moonshot.cn/v1', model: 'moonshot-v1-8k'},
					{key: 'qwen', name: '通义千问', baseUrl: 'https://dashscope.aliyuncs.com/compatible-mode/v1', model: 'qwen-plus'},
					{key: 'zhipu', name: '智谱GLM', baseUrl: 'https://open.bigmodel.cn/api/paas/v4', model: 'glm-4-flash'},
					{key: 'openai', name: 'OpenAI', baseUrl: 'https://api.openai.com/v1', model: 'gpt-4o-mini'}
				]
			}
		},
		methods: {
			loadConfig() {
				this.$api.ai.config().then(({data}) => {
					if (data) {
						this.form = {
							enabled: !!data.enabled,
							baseUrl: data.baseUrl || '',
							apiKey: data.apiKey || '',
							model: data.model || '',
							maxRounds: data.maxRounds != null ? data.maxRounds : 10,
							temperature: data.temperature != null ? Number(data.temperature) : 0.3,
							maxTokens: data.maxTokens != null ? data.maxTokens : 4096
						};
					}
				});
			},
			applyProvider(p) {
				this.form.baseUrl = p.baseUrl;
				this.form.model = p.model;
			},
			validate() {
				if (!this.form.baseUrl) {
					this.$Message.error('请填写 API 地址');
					return false;
				}
				if (!this.form.model) {
					this.$Message.error('请填写模型名称');
					return false;
				}
				if (this.form.enabled && !this.form.apiKey) {
					this.$Message.error('启用智能体前请填写 API Key');
					return false;
				}
				return true;
			},
			save() {
				if (!this.validate()) {
					return;
				}
				this.saving = true;
				this.$api.ai.saveConfig(this.form).then(({msg}) => {
					this.$Message.success(msg || '保存成功');
					this.loadConfig();
				}).finally(() => this.saving = false);
			},
			test() {
				if (!this.form.baseUrl || !this.form.apiKey || !this.form.model) {
					this.$Message.error('请先填写 API 地址、API Key 和模型名称');
					return;
				}
				this.testing = true;
				this.$api.ai.testConfig(this.form).then(({msg}) => {
					this.$Message.success(msg || '连接成功');
				}).finally(() => this.testing = false);
			}
		},
		mounted() {
			this.loadConfig();
		}
	}
</script>

<style scoped>
	.ai-tip {
		color: #999;
		font-size: 12px;
		margin-top: 5px;
	}

	.ai-status {
		border: 1px solid #eaeaea;
		border-radius: 6px;
		padding: 20px;
	}

	.ai-status-title {
		font-weight: bold;
		margin-bottom: 12px;
	}

	.ai-status-row {
		margin-bottom: 10px;
	}

	.ai-status-tip {
		color: #999;
		font-size: 12px;
		margin-top: 10px;
		line-height: 1.6;
	}
</style>
